export const ORIGIN = process.env.ORIGIN;
export const TEST_ORIGIN = process.env.TEST_ORIGIN;
export const STAGE_ORIGIN = process.env.STAGE_ORIGIN;
export const DEFAULT_REVALIDATE_INTERVAL = 86400; // 1 day
export const IS_PROD = process.env.IS_PRODUCTION; // may be mistake
export const GA_PRIVATE_KEY = process.env.GA_PRIVATE_KEY;
export const GA_CLIENT_EMAIL = process.env.GA_CLIENT_EMAIL;
export const GA_CLIENT_ID = process.env.GA_CLIENT_ID;
export const GA_PROPERTY_ID = process.env.GA_PROPERTY_ID;
export const GA_PROPERTY_LEGACY_ID = process.env.GA_PROPERTY_LEGACY_ID;
export const FB_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID;
export const CRISP_CHAT_TOKEN = process.env.CRISP_CHAT_TOKEN || '';

export const GOOGLE_TAG_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_ID || '';

// finally enable this for Prod environment
// while non-production - set to false directly
// export const IS_FACEBOOK_PIXEL_ENABLED = PROD_CHECK;
export const IS_FACEBOOK_PIXEL_ENABLED = process.env.IS_PRODUCTION;
